import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-analyticscalllogsstats',
  templateUrl: './analyticscalllogsstats.component.html',
  styleUrls: ['./analyticscalllogsstats.component.css']
})
export class AnalyticscalllogsstatsComponent implements OnInit {
  @Input('final_score') final_score: any;
  saving = false;
  @Output() saveAnalytics = new EventEmitter();
  @Output() modifyAnalytics = new EventEmitter();
  constructor(private _location: Location) {
  }

  ngOnInit() {
    console.log(this.final_score);
  }
  saveSMSAnalyticsResult() {
    this.saveAnalytics.emit();
  }
  modifyAnalyticsResult() {
    this.modifyAnalytics.emit();
  }
  goBack() {
    this._location.back()
  }
}
